import React from "react";
import PrimaryButton from "../inputs/buttons/Button";
import { Link } from "gatsby";
import { usePageSettings } from "../../../contexts/PageSettingsContext";
import { getTranslatedCityName } from "../../../utils/getTranslatedCityName";
import { constructUrl } from "../../../utils/constructUrl";

const ContactUsBanner = ({ title, subtitle, contactText }) => {
	const { pageSettingsContext } = usePageSettings();
	const { country, language, city } = pageSettingsContext;

	const citySlug = getTranslatedCityName(language, city);

	return (
		<section className="flex flex-col items-start md:items-center text-white gap-3 md:text-center justify-center mb-0">
			<h3 className="font-bold text-xl md:text-2xl mr-auto md:mr-0">
				{title}
			</h3>
			<p className="opacity-50 text-base max-w-[650px] mr-auto md:mr-0 empty:hidden">
				{subtitle}
			</p>
			<Link to={constructUrl(language, country, citySlug, "/contact-us")}>
				<PrimaryButton>{contactText}</PrimaryButton>
			</Link>
		</section>
	);
};

export default ContactUsBanner;
